<template>
  <div id="app" class="h-100" :class="[skinClasses]">
    <component :is="layout">
      <router-view />
    </component>
    <b-modal id="modal-send-settings" title="اعدادات الارسال" hide-footer>
      <div id="c4934oofdsfsdf" style="border-right: 2px solid green;">
        <strong class="text-success g">
            <i class="fa fa-whatsapp"></i> الارسال عبر الواتساب<br>
          </strong>
        <div class="col-12 g">
          <b-form-checkbox
            checked="true"
            name="check-button"
            inline
            value="whatsapp-api"
            v-model="selected"
          >
          <h5>
            <i class="fa fa-whatsapp"></i>
            ارسال عبر خدمة <strong><u>الواتس الذكي</u></strong>
          </h5>
          </b-form-checkbox>
        </div>
        <div class="col-12 g" v-if="!isMobileApp">
          <b-form-checkbox
            checked="true"
            name="check-button"
            inline
            value="whatsapp"
            v-model="selected"
          >
          <h5>
            <i class="fa fa-whatsapp"></i>
            ارسال عبر اداة الواتساب (من المتصفح)
          </h5>
          </b-form-checkbox>
        </div>
        <div class="col-12 g">
          <b-form-checkbox
            checked="true"
            name="check-button"
            inline
            value="xwa"
            v-model="selected"
          >
          <h5>
            <i class="fa fa-whatsapp"></i>
            الأداة المتطورة (الواتس المباشر)
          </h5>
          </b-form-checkbox>
        </div>
        <div class="g" style="margin-top: -10px">
          <a href="/whats-methods" style="color: #2845D6" target="_blank">
            ما الفرق بينهم؟
          </a>
        </div>
      </div><br>
      <div id="c4934oofdsfsdf" style="border-right: 2px solid darkred;">
        <strong class="text-danger g">
            <i class="fa fa-phone"></i> الارسال عبر الرسائل النصية (SMS)<br>
          </strong>
      <div class="col-12 g">
        <b-form-checkbox
          checked="true"
          name="check-button"
          inline
          value="sms"
          v-model="selected"
        >
        <h5>
          <i class="fa fa-phone"></i>
          ارسال عبر الرسائل النصية SMS
        </h5>
        </b-form-checkbox>
      </div>
      </div>
      <div class="col-12 g" v-if="selected == 'whatsapp-api'">
        <div class="form-group">
          <label for="">رقم جوال الواتس الذكي</label>
          <input type="text"
            class="form-control" v-model="smart_phone">
          <small id="helpId" class="form-text text-muted">المُسجل به في الخدمة</small>
        </div>
        <div class="form-group">
          <label for="">كلمة مرور الواتس الذكي</label>
          <input type="password"
            class="form-control" v-model="smart_password">
          <small id="helpId" class="form-text text-muted">المُسجل بها في الخدمة</small>
        </div>
        <div class="col-12 text-center g">
          <span class="border g">لمزيد من التفاصيل حول خدمة الواتس الذكي <a href="https://smart-whats.com" target="_blank"><strong><u>إضغط هنا</u></strong></a></span>
        </div>
      </div>
      <div class="col-12 g" v-if="selected == 'xwa'">
        <div class="form-group">
          <label for="">رقم جوال الواتس المباشر</label>
          <input type="text"
            class="form-control" v-model="xwa_phone">
          <small id="helpId" class="form-text text-muted">المُسجل به في الخدمة</small>
        </div>
        <div class="form-group">
          <label for="">كلمة مرور الواتس المباشر</label>
          <input type="password"
            class="form-control" v-model="xwa_password">
          <small id="helpId" class="form-text text-muted">المُسجل بها في الخدمة</small>
        </div>
        <div class="col-12 text-center g">
          <span class="border g">لمزيد من التفاصيل حول خدمة الواتس المباشر <a href="https://wa.smart-whats.com" target="_blank"><strong><u>إضغط هنا</u></strong></a></span>
        </div>
      </div>
      <div class="col-12 g" v-if="selected == 'sms'">
        <div class="form-group">
          <label for="">البوابة / مزود الخدمة</label>
          <select class="form-control" v-model="sms_portal">
            <option :value="null">-- اختر البوابة --</option>
            <option value="oursms">رسائلنا - oursms</option>
            <option value="saudisms">رسائل السعودية - saudisms.net</option>
            <!-- <option value="mora">"شركة مورا للإتصالات - Mora Telecom Co</option> -->
            <option value="4jawaly">فور جوالي - 4jawaly</option>
            <option value="malath">ملاذ اس ام اس</option><option value="yamamah">يمامه - Yamamah</option><option value="hisms">هاي اس ام اسم - hisms</option><option value="goldenskills">المهارات الذهبية - goldenskills</option><option value="shamelsms">الشامل - نور الشبكي</option><option value="bulksmssa">bulksms-sa</option><option value="jawalbsms">jawalbsms</option><option value="taqnyat">شركة تقنيات الجوال - taqnyat.sa</option><option value="vip1sms">تقنيات الرسالة - vip1sms.com</option>
            <option value="orbit">المدار التقني - mobile.net.sa</option>
            <option value="orbit-new">المدار التقني الجديد - app.mobile.net.sa</option>
            <option value="fsms">FSMS</option>
          </select>
        </div>
        <!-- <div class="form-group" v-if="sms_portal != 'orbit-new'">
          <label for="">اسم المستخدم</label>
          <input type="text"
            class="form-control" v-model="sms_username">
        </div>
        <div class="form-group">
          <label for="">{{ sms_portal == 'orbit-new' ? 'رمز API' : 'كلمة المرور' }}</label>
          <input type="password"
            class="form-control" v-model="sms_password">
        </div>
        <div class="form-group">
          <label for="">اسم المرسل</label>
          <input type="text"
            class="form-control" v-model="sms_sendername">
        </div>
         -->
         <template v-if="sms_portal != '4jawaly'">
            <template v-if="sms_portal != 'taqnyat' && sms_portal != 'smart-whats'">
                <div class="form-group"><label for="">{{ sms_portal == 'orbit-new' ? '' : 'اسم المستخدم' }}</label>
                <input v-model="sms_username" type="text" class="form-control dnone" disabled v-if="sms_portal == 'orbit-new'">
                <input v-model="sms_username" type="text" class="form-control" v-if="sms_portal != 'orbit-new'"></div>
                <div class="form-group"><label for="">{{ sms_portal == 'orbit-new' || sms_portal == 'oursms' ? 'رمز API' : 'كلمة المرور' }}</label><input v-model="sms_password" type="password" class="form-control"></div>
            </template>
            <div class="form-group" v-if="sms_portal == 'taqnyat'"><label for="">Token</label><input v-model="sms_username" type="text" class="form-control"></div>
            <div class="form-group" v-if="sms_portal == 'smart-whats'"><label for="">JWT</label><input v-model="sms_username" type="text" class="form-control"></div>
            <div class="form-group" v-if="sms_portal == 'smart-whats'"><label for="">Device ID</label><input v-model="sms_password" type="text" class="form-control"></div>
            <div class="form-group" v-if="sms_portal != 'smart-whats'"><label for="">اسم المرسل</label><input v-model="sms_sendername" type="text" class="form-control"></div>
        </template>
        <template v-if="sms_portal == '4jawaly'">
            <div class="form-group"><label for="">App ID</label><input v-model="sms_username" type="text" class="form-control"></div>
            <div class="form-group"><label for="">App Secret</label><input v-model="sms_password" type="text" class="form-control"></div>
            <div class="form-group"><label for="">اسم المرسل</label><input v-model="sms_sendername" type="text" class="form-control"></div>
        </template>
      </div>
      <div v-if="selected" class="col-12 text-center g">
        <button class="btn btn-primary" @click="done()">حفظ ومتابعة <i class="fa fa-arrow-left"></i></button>
      </div>
    </b-modal>
    <button
      class="dnone"
      id="c-subscribe-ended"
      v-b-modal.modal-send-settings
    ></button>
    <input id='after-send-settings-click' style='display:none'>
  </div>
</template>

<script>
import { VBModal, BModal, BFormCheckbox } from "bootstrap-vue";
// This will be populated in `beforeCreate` hook
import { $themeColors, $themeBreakpoints, $themeConfig } from "@themeConfig";
import { provideToast } from "vue-toastification/composition";
import { watch } from "@vue/composition-api";
import useAppConfig from "@core/app-config/useAppConfig";
import Ripple from "vue-ripple-directive";

import { useWindowSize, useCssVar } from "@vueuse/core";

import store from "@/store";

const LayoutVertical = () => import("@/layouts/vertical/LayoutVertical.vue");
const LayoutHorizontal = () =>
  import("@/layouts/horizontal/LayoutHorizontal.vue");
const LayoutFull = () => import("@/layouts/full/LayoutFull.vue");

export default {
  data(){
    return {
      selected: null,
      sms_username: null,
      sms_password: null,
      sms_portal: null,
      sms_sendername: null,
      smart_phone: null,
      isMobileApp: window.location.href.includes("/mobile/"),
      smart_password: null,
      xwa_phone: null,
      xwa_password: null
    }
  },
  created() {
    if(window.location.href.includes("school_id=")){
      localStorage.setItem("school_id", window.location.href.split("school_id=")[1].split("&")[0]);
    }
    if(!localStorage.getItem('send')){
      return;
    }
    var obj = JSON.parse(localStorage.getItem('send'))
    this.sms_portal = obj.sms_portal
    this.sms_username = obj.sms_username
    this.sms_password = obj.sms_password
    this.sms_sendername = obj.sms_sendername
    this.smart_phone = obj.smart_phone
    this.smart_password = obj.smart_password
    this.xwa_phone = obj.xwa_phone
    this.xwa_password = obj.xwa_password
    this.selected = obj.selected
    setTimeout(() => {
        $(".h-100").removeClass("h-100")
    }, 100);
  },
  methods: {
    done(){
      var obj = {
        selected: this.selected,
        sms_username: this.sms_username,
        sms_password: this.sms_password,
        sms_portal: this.sms_portal,
        sms_sendername: this.sms_sendername,
        smart_phone: this.smart_phone,
        smart_password: this.smart_password,
        xwa_phone: this.xwa_phone,
        xwa_password: this.xwa_password
      }
      localStorage.setItem("send", JSON.stringify(obj))
      $("#modal-send-settings___BV_modal_header_ > button").click()
      setTimeout(() => {
        $($("#after-send-settings-click").val()).click()
      }, 500);
    }
  },
  directives: {
    Ripple,
    "b-modal": VBModal,
  },
  components: {
    // Layouts
    BModal,BFormCheckbox,
    LayoutHorizontal,
    LayoutVertical,
    LayoutFull,
  },
  // ! We can move this computed: layout & contentLayoutType once we get to use Vue 3
  // Currently, router.currentRoute is not reactive and doesn't trigger any change
  computed: {
    layout() {
      if (this.$route.meta.layout === "full") return "layout-full";
      return `layout-${this.contentLayoutType}`;
    },
    contentLayoutType() {
      return this.$store.state.appConfig.layout.type;
    },
  },
  beforeCreate() {
    // Set colors in theme
    const colors = [
      "primary",
      "secondary",
      "success",
      "info",
      "warning",
      "danger",
      "light",
      "dark",
    ];

    // eslint-disable-next-line no-plusplus
    for (let i = 0, len = colors.length; i < len; i++) {
      $themeColors[colors[i]] = useCssVar(
        `--${colors[i]}`,
        document.documentElement
      ).value.trim();
    }

    // Set Theme Breakpoints
    const breakpoints = ["xs", "sm", "md", "lg", "xl"];

    // eslint-disable-next-line no-plusplus
    for (let i = 0, len = breakpoints.length; i < len; i++) {
      $themeBreakpoints[breakpoints[i]] = Number(
        useCssVar(
          `--breakpoint-${breakpoints[i]}`,
          document.documentElement
        ).value.slice(0, -2)
      );
    }

    // Set RTL
    const { isRTL } = $themeConfig.layout;
    document.documentElement.setAttribute("dir", isRTL ? "rtl" : "ltr");
  },
  setup() {
    const { skin, skinClasses } = useAppConfig();

    // If skin is dark when initialized => Add class to body
    if (skin.value === "dark") document.body.classList.add("dark-layout");

    // Provide toast for Composition API usage
    // This for those apps/components which uses composition API
    // Demos will still use Options API for ease
    provideToast({
      hideProgressBar: true,
      closeOnClick: false,
      closeButton: false,
      icon: false,
      timeout: 3000,
      transition: "Vue-Toastification__fade",
    });

    // Set Window Width in store
    store.commit("app/UPDATE_WINDOW_WIDTH", window.innerWidth);
    const { width: windowWidth } = useWindowSize();
    watch(windowWidth, (val) => {
      store.commit("app/UPDATE_WINDOW_WIDTH", val);
    });

    return {
      skinClasses,
    };
  },
};
</script>